import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Empty from '../../components/service/common/Empty';
import S from './Update.module.scss';
export const UpdateAppPageView = () => {
  const {
    t
  } = useTranslation(['common']);
  const router = useRouter();
  useEffect(() => {
    const redirectUrl = t('common:appRemove.014164c3') as string;
    router.replace(redirectUrl);
  }, [router, t]);
  return <div className={S.empty_wrapper} data-sentry-component="UpdateAppPageView" data-sentry-source-file="update.tsx">
      <Empty image={{
      url: '/images/light/common/common_alert.png',
      width: 241,
      height: 149
    }} emptyItem={'Zep App is no longer available.'} useCustomMessage={true} data-sentry-element="Empty" data-sentry-source-file="update.tsx" />
    </div>;
};